<template>
  <main class="flex h-screen flex-col justify-between overflow-y-auto scroll-smooth bg-gray-200 scrollbar-track-gray-200 scrollbar-thumb-primary-300 dark:bg-gray-900 dark:scrollbar-thumb-gray-700 dark:scrollbar-track-gray-900 lg:scrollbar-thin">
    <slot></slot>
  </main>
</template>
